import React, { useState } from "react";
import openArrow from "../../images/hackathon/arrow-open.svg";
import closeArrow from "../../images/hackathon/arrow-closed.svg";


const sections = [
  {
    title: "DeFi on Bitcoin",
    color: "#00e6ff",
    content: "Create DeFi applications using the Rootstock network and/or RIF tools, to easily build lending protocols, decentralized exchanges, yield farming strategies, liquidity pools, insurance protocols, decentralized credit scoring, or trading bots.",
    bgColor: "cyan", 
  },
  {
    title: "Runes or Ordinals",
    color: "#ff9300",
    content: "Tap into Bitcoin's liquidity and experiment with the latest trends. Develop dApps that use ordinals and runes to create digital assets and offer fresh ways to interact and manage these assets on the blockchain.",
    bgColor: "orange", 
  },
  {
    title: "Tokenized RWA",
    color: "#ff00e5",
    content: "Build solutions that connect real-world assets like property, commodities, and financial instruments to the blockchain using smart contracts. Explore ways to enhance transparency, efficiency, and security in real-world transactions.",
    bgColor: "pink", 
  },
  {
    title: "Cross-chain Interoperability",
    color: "#a784ff",
    content: "Enhance Bitcoin’s cross-chain interoperability, using Rootstock’s EVM compatible smart contracts.",
    bgColor: "purple", 
  },
  {
    title: "Freestyle it",
    color: "#d0ff00",
    content: "Builders are always encouraged to expand Bitcoin’s functionality. With leading developer tools, oracles, indexers Rootstock provides you  the most advanced and complete infrastructure to build anything you envision on Bitcoin.",
    bgColor: "green", 
  }
];

export const Accordian = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index); // Toggle visibility
  };

  return (
    <section className="what-to-build-section container">
      <div className="left-content">
        <span className="zg-label bg-yellow mb-5">BUILD</span>
        <h2 className="h3 mb-5">What to build on Rootstock</h2>
        <p>
        Rootstock combines Ethereum’s programmability with Bitcoin’s security. Build EVM dApps, DeFi protocols, and more, leveraging Bitcoin’s security. Whether scaling the Bitcoin ecosystem or driving decentralized innovation, Rootstock is your gateway to smart contracts on Bitcoin.
        </p>
      </div>

      <div className="right-content">
        {sections.map((section, index) => (
          <div key={index} className="section-item">
            <div
              className="section-header"
              onClick={() => toggleSection(index)}
            >
              <h3 className={`h4 zg-line-height-sm letter-spacing-1 p-2 mb-1 me-5 bg-${section.bgColor}`}>
                {section.title}
              </h3>
              <span className="arrow">
                <img 
                  src={activeIndex === index ? openArrow : closeArrow} 
                  alt={activeIndex === index ? "Collapse section" : "Expand section"}
                  style={{ width: '24px', height: '24px' }}
                />
              </span>
            </div>
            {activeIndex === index && (
              <div className="section-content">
                <p>{section.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>      
    </section>
  );
};
